<template>
  <filter-bar title="Descarga de Reporte de Compras">
    <form class="md-layout md-gutter" id="report-form" @submit.prevent="downloadReport">
      <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
        <md-field>
          <label for="dateFrom">
            <md-icon>calendar_today</md-icon>
            <span v-show="!params.dateFrom">Desde</span>
          </label>
          <datetime
            input-style="border: none; outline:none; width: 100%"
            type="date"
            title="Desde"
            value-zone="America/Mexico_City"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
            v-model="params.dateFrom"
          ></datetime>
          <md-button class="md-simple md-just-icon" @click="params.dateFrom = null">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>

      <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
        <md-field>
          <label for="dateOccurred">
            <md-icon>calendar_today</md-icon>Hasta
          </label>
          <datetime
            input-style="border: none; outline:none; width: 100%"
            type="date"
            title="Hasta"
            value-zone="America/Mexico_City"
            :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
            v-model="params.dateTo"
          ></datetime>
          <md-button class="md-simple md-just-icon" @click="params.dateTo = null">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>

      <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
        <md-field>
          <label>Campamento</label>
          <md-select v-model="params.camp">
            <md-option :value="0">Todos</md-option>
            <md-option v-for="camp in camps" :key="camp.id" :value="camp.id">{{camp.name}}</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
        <md-field>
          <label>No Sin, orden o requisicion</label>
          <md-input v-model="params.searchedWord"></md-input>
        </md-field>
      </div>
    </form>
    <template slot="actions">
      <strong
        class="text-info"
      >Seleccione opcionalmente un rango para filtrar por fecha de validación de compra.</strong>
      <md-button
        class="md-success md-round md-sm"
        type="submit"
        form="report-form"
        :disabled="downloading"
      >
        <md-icon>insert_chart</md-icon>Descargar
      </md-button>
    </template>
  </filter-bar>
</template>

<script>
import FilterBar from "@/components/FilterBar";
import catalogService from "@/services/catalog";
import purchaseService from "@/services/purchase";

export default {
  name: "PurchasesReport",

  components: {
    FilterBar,
  },

  data() {
    return {
      downloading: null,
      camps: [],
      params: {
        dateFrom: null,
        dateTo: null,
        camp: 0,
        searchedWord: "",
      },
    };
  },

  mounted() {
    this.fetchCamps();
  },

  methods: {
    downloadReport() {
      this.downloading = true;
      return purchaseService
        .fetchPurchaseReport(this.params)
        .then((report) => {
          this.$notify({
            message: "Reporte Descargado",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            type: "success",
          });
        })
        .catch((err) => {
          const { status } = err.response;
          this.$notify({
            message:
              status == 400
                ? "No se pudo descargar el reporte"
                : "Error descargando reporte",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            type: status === 400 ? "warning" : "danger",
          });
        })
        .finally(() => {
          this.downloading = false;
        });
    },
    fetchCamps() {
      return catalogService
        .fetch("highway/camp")
        .then((response) => (this.camps = response));
    },
  },
};
</script>

<style lang="css" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}

.md-card-actions {
  display: flex;
  justify-content: space-between !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Purchases/Report.vue